import React from 'react'
import {
  makeStyles,
  createStyles,
  Theme,
  Typography,
  // Grid,
  //Fab,
} from '@material-ui/core'
import { Cart } from '../../typings/base'
import CMSText from '../Global/CMSText'
import clsx from 'clsx'
import Price from './Price'
import { displayTtcAndHtPrice } from '@/utils/constants'
// import DeleteForeverIcon from '@material-ui/icons/DeleteForever'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapperShipping: {
      margin: 0,
      padding: theme.spacing(1),
    },
    rowBorder: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: theme.spacing(1, 0.5),
      borderTop: `1px solid ${theme.extraColors.greyLight}`,
    },
    left: {
      display: 'flex',
      flexDirection: 'row',
    },
    green: {
      color: theme.palette.success.main,
    },
    rowNoBorder: {
      border: 0,
    },
    delete: {
      width: 20,
      height: 20,
      minHeight: 20,
      padding: 0,
      boxShadow: 'none',
      background: 'none',
      '&:hover, &:focus': {
        color: theme.palette.error.main,
        background: 'none',
      },
      '& .MuiSvgIcon-root': {
        height: '.75em',
        width: '.75em',
      },
    },
    row: {
      display: 'flex',
      padding: theme.spacing(1, 0.5),
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  })
)

type Tprops = {
  cart?: Cart
  t: any
  basket: any
  settings?: any
  user?: any
  includeShipping: boolean
  deleteCoupon: () => Promise<void>
}

const BasketTotalsSecondHand = ({
  t,
  basket,
  cart,
  settings,
  includeShipping,
  deleteCoupon,
}: Tprops) => {
  const basketSecondHandClasses = useStyles()
  return (
    <div className={basketSecondHandClasses.wrapperShipping}>
      {/* <div className={basketSecondHandClasses.rowBorder}>
        <Typography variant={'body2'}>
          <CMSText
            asText
            data={basket?.data?.voucher_text_explication}
            defaultText={t('texts:basket:reduction_text_explication')}
          />
        </Typography>
      </div> */}
      {basket?.data?.enable_reduction &&
        (cart.item.totals.promotion !== 0 ? (
          <div className={basketSecondHandClasses.rowBorder}>
            <Typography variant={'body2'}>
              <CMSText
                asText
                data={basket?.data?.reduction}
                defaultText={t('texts:basket:reduction')}
              />
              &nbsp;
            </Typography>
            <div className={basketSecondHandClasses.left}>
              <Typography
                variant={'body2'}
                className={clsx(
                  'basket__discount',
                  basketSecondHandClasses.green
                )}
              >
                <b>
                  <Price
                    amount={cart.item.totals.promotion}
                    showDayOrMonth={false}
                    dayOrMonth={settings?.day_or_month}
                    dayOrMonthShort={settings?.day_or_month_short}
                  />
                </b>
              </Typography>
              {/* <Grid item xs="auto">
                <Fab
                  size="small"
                  className={basketSecondHandClasses.delete}
                  onClick={deleteCoupon}
                >
                  <DeleteForeverIcon />
                </Fab>
              </Grid> */}
            </div>
          </div>
        ) : (
          <div className={basketSecondHandClasses.rowBorder}>
            <Typography variant={'body2'}>
              <CMSText
                asText
                data={basket?.data?.reduction_text_explication}
                defaultText={t('texts:basket:reduction_text_explication')}
              />
            </Typography>
          </div>
        ))}
      {displayTtcAndHtPrice ? (
        <>
          {/* Net Total price without shipping */}
          <div className={basketSecondHandClasses.row}>
            <Typography variant={'body2'}>
              <CMSText
                asText
                data={basket?.data?.total_excl_vat}
                defaultText={t('texts:basket:total_without_shipping_excl_vat')}
              />
            </Typography>
            <div className={basketSecondHandClasses.left}>
              <Typography variant={'body2'}>
                <b>
                  <Price
                    amount={cart?.item?.totals?.itemsBeforeTax}
                    showDayOrMonth={false}
                    dayOrMonth={settings?.day_or_month}
                    dayOrMonthShort={settings?.day_or_month_short}
                  />
                </b>
              </Typography>
            </div>
          </div>
          {/* Shipping Fees Net */}
          {includeShipping && (
            <div className={basketSecondHandClasses.row}>
              <Typography variant={'body2'}>
                <CMSText
                  asText
                  data={basket?.data?.delivery_fees_excl_vat}
                  defaultText={t('texts:basket:delivery_fees_excl_vat')}
                />
              </Typography>
              <div className={basketSecondHandClasses.left}>
                <Typography variant={'body2'}>
                  <b>
                    <Price
                      amount={cart?.item?.totals?.shippingBeforeTax}
                      showDayOrMonth={false}
                      dayOrMonth={settings?.day_or_month}
                      dayOrMonthShort={settings?.day_or_month_short}
                    />
                  </b>
                </Typography>
              </div>
            </div>
          )}
          {/* VAT */}
          <div className={basketSecondHandClasses.row}>
            <Typography variant={'body2'}>
              <CMSText
                asText
                data={basket?.data?.vat}
                defaultText={t('texts:basket:vat')}
              />
            </Typography>
            <div className={basketSecondHandClasses.left}>
              <Typography variant={'body2'}>
                <b>
                  <Price
                    amount={
                      includeShipping
                        ? cart?.item?.totals?.taxes
                        : cart?.item?.totals?.itemTaxes
                    }
                    showDayOrMonth={false}
                    dayOrMonth={settings?.day_or_month}
                    dayOrMonthShort={settings?.day_or_month_short}
                  />
                </b>
              </Typography>
            </div>
          </div>
        </>
      ) : (
        <>
          {/* Gross Total price without shipping */}
          <div className={basketSecondHandClasses.row}>
            <Typography variant={'body2'}>
              <CMSText
                asText
                data={basket?.data?.total_without_shipping}
                defaultText={t('texts:basket:total_without_shipping')}
              />
            </Typography>
            <div className={basketSecondHandClasses.left}>
              <Typography variant={'body2'}>
                <b>
                  <Price
                    amount={cart?.item?.totals?.totalSecondHand}
                    showDayOrMonth={false}
                    dayOrMonth={settings?.day_or_month}
                    dayOrMonthShort={settings?.day_or_month_short}
                  />
                </b>
              </Typography>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default BasketTotalsSecondHand
